import type { ReactNode } from "react";

import { Button } from "@alpacahq/ui/old";

import { SealCheckIcon } from "~/v2/components/common";

export interface AgreementProps {
  isAccepted: boolean;
  label: ReactNode;
  onOpen: () => void;
}

export const AgreementBox = ({ isAccepted, label, onOpen }: AgreementProps) => (
  <article className="flex items-center justify-between gap-4 rounded border border-gray-300 bg-white p-2">
    <div className="flex items-center justify-start gap-2">
      {isAccepted && <SealCheckIcon />}
      <h3 className="m-0 p-0 font-semibold text-gray-800 text-sm">{label}</h3>
    </div>
    {isAccepted ? (
      <Button
        key={`view-terms-${label}`}
        variant="v2/ghost"
        size="v2/small"
        onClick={onOpen}
        className="whitespace-nowrap"
      >
        View Terms
      </Button>
    ) : (
      <Button
        key={`open-${label}`}
        variant="v2/filled"
        size="v2/small"
        onClick={onOpen}
      >
        Open
      </Button>
    )}
  </article>
);
